/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Asynchronní továrna na zdroje zobrazování PDF médií
 * v podobě HTML iframe elementu
 * ve kterém je načtená aplikace PDF prohlížeče.
 */
class PdfViewerSourceFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<PdfViewerSource>} PdfViewerSource
   * @param {ViewerSourceIframeCreator} iframeCreator
   * @param {PdfParentFactory} parentFactory
   */
  constructor(PdfViewerSource, iframeCreator, parentFactory) {
    this.PdfViewerSource = PdfViewerSource;
    this.iframeCreator = iframeCreator;
    this.parentEl = null;
    this.parentFactory = parentFactory;
    this.scheduleInfo = null;
  }

  /**
   * Vytvoří nový zdroj pro zobrazení PDF média.
   * @returns {Promise.<PdfViewerSource>}
   */
  create() {
    return new Promise((resolve) =>
      resolve(
        this.iframeCreator
          .lend(this.parentEl, this.scheduleInfo)
          .then((sourceIframe) => {
            const iframe = sourceIframe.getEl();
            const parent = this.parentFactory.create(iframe);
            return new this.PdfViewerSource(parent, sourceIframe);
          })
      )
    );
  }

  /**
   * Smaže zdroj pro zobrazení média.
   * @param {PdfViewerSource} source Zdroj ke smazání.
   * @returns {Promise.<undefined>}
   */
  delete(source) {
    return source.destroy();
  }

  /**
   * Nastaví rodičovský element, určený pro vkládání elementů zdroje.
   * @param {HTMLElement} parentEl
   * @returns {undefined}
   */
  setParentEl(parentEl) {
    this.parentEl = parentEl;
  }

  /**
   * Nastaví naplánované médium, určené pro žádost o iframe element.
   * @param {ScheduleInfo} scheduleInfo
   * @returns {undefined}
   */
  setScheduleInfo(scheduleInfo) {
    this.scheduleInfo = scheduleInfo;
  }
}

export default PdfViewerSourceFactory;
